class StPassengersController {
    constructor($translate) {
        'ngInject';
        this.name = 'stPassengers';
        //Infants array
        // this.years = [...Array(18).keys()];
        this.years = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 17];
        // this.months = [...Array(12).keys()];
        this.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        this.$translate = $translate;
    }

    $onInit() {
        this.showInfants = this.data.passengers.infants.length ? true : false;
        this.translations = this.$translate.instant([
            "n_transfer_extras",
            "title_col1",
            "click_here",
            "additional_children",
            "option_infant",
            "all_adults",
            "infants_children",
            "passengers_number",
            "pass_total",
            "option_years",
            "option_months"
        ]);
    }

    updatePassengers(transfer) {
        let maxChildren = transfer.passengers.total - 1;
        if (maxChildren < transfer.passengers.infants.length) {
            transfer.passengers.infants = transfer.passengers.infants.slice(0, maxChildren);
        }
    }

    toggleAddExtraChild(transfer, value) {
        if (value == false) {
            this.showInfants = false;
        } else {
            this.showInfants = true;
        }
    }

    addExtraChild(transfer) {
        let maxPassengers = transfer.passengers.total - 1;
        if (transfer.passengers.infants.length < maxPassengers) {
            transfer.passengers.infants.push({
                "years": 1,
                "months": 0
            });
        }
    }

    removeExtraChild(transfer, i) {
        transfer.passengers.infants.splice(i, 1);
    }
    
    range(num) {
        // return [...Array(1 + num).keys()].map(v => 1 + v);
        let arr = new Array(num);
        for (let i = 0; i < arr.length; i++) {
            arr[i] = 1 + i;
        }
        return arr;
    }

}

export default StPassengersController;



// WEBPACK FOOTER //
// ./client/app/common/stPassengers/stPassengers.controller.js